/* ================================================================
   filterData.js — single source of truth for every filter list
   used across Home.jsx and FilterSheet.jsx
================================================================ */

export const PLACEHOLDER_PLACES = [
  'Saket', 'Hauz Khaas', 'Connaught Place', 'Lajpat Nagar',
  'Karol Bagh', 'Dwarka', 'Rohini', 'Janakpuri',
  'Vasant Kunj', 'Greater Kailash',
];

/* Shown as a single scrollable row right under the hero — the
   filters people actually tap most often. Kept short on purpose. */
export const QUICK_FILTERS = [
  // { emoji: '🌟', label: 'All',          cuisineVal: null,           isVeg: false },
  // { emoji: '🥢', label: 'Chinese',      cuisineVal: 'chinese',      isVeg: false },
  // { emoji: '🫓', label: 'South Indian', cuisineVal: 'south-indian', isVeg: false },
  // { emoji: '🍕', label: 'Pizza',        cuisineVal: 'italian',      isVeg: false },
  // { emoji: '🍛', label: 'Biryani',      cuisineVal: 'mughlai',      isVeg: false },
  // { emoji: '☕', label: 'Cafés',        cuisineVal: 'cafe',         isVeg: false },
  { emoji: '', label: 'Veg Only',     cuisineVal: null,           isVeg: true  },
  // {emoji: '', label: 'Open Now',     cuisineVal: null,           isOpen: true }
];

export const AMBIENCE_FILTERS = [
  { emoji: '🏙️', label: 'Rooftop',          val: 'rooftop' },
  { emoji: '🌿', label: 'Open Garden',       val: 'open-garden' },
  { emoji: '🌤️', label: 'Open Roof Ground',  val: 'open-roof-ground' },
  { emoji: '🕯️', label: 'Candlelit',         val: 'candlelit' },
  { emoji: '🎵', label: 'Live Music',        val: 'live-music' },
  { emoji: '🌊', label: 'Waterfront',        val: 'waterfront' },
  { emoji: '🏡', label: 'Rustic Cottage',    val: 'rustic-cottage' },
  { emoji: '🌃', label: 'Night View',        val: 'night-view' },
  { emoji: '🪵', label: 'Bonfire Seating',   val: 'bonfire' },
  { emoji: '🌁', label: 'Terrace',           val: 'terrace' },
  { emoji: '🏖️', label: 'Beach Shack',       val: 'beach' },
  { emoji: '📚', label: 'Book Café',         val: 'book-cafe' },
  { emoji: '🎨', label: 'Art Café',          val: 'art-cafe' },
  { emoji: '🐾', label: 'Pet Friendly',      val: 'pet-friendly' },
  { emoji: '💻', label: 'Work-Friendly',     val: 'work-friendly' },
  { emoji: '🌙', label: 'Late Night',        val: 'late-night' },
];

export const VIBE_FILTERS = [
  { emoji: '🎭', label: 'Malayalam Theme',   val: 'malayalam' },
  { emoji: '🌺', label: 'Kannada Theme',     val: 'kannada' },
  { emoji: '🪔', label: 'Tamil Theme',       val: 'tamil' },
  { emoji: '🦚', label: 'Telugu Theme',      val: 'telugu' },
  { emoji: '🏮', label: 'Chinese Theme',     val: 'chinese-vibe' },
  { emoji: '⛩️', label: 'Japanese Theme',    val: 'japanese-vibe' },
  { emoji: '🕌', label: 'Arabian Nights',    val: 'arabian' },
  { emoji: '🎪', label: 'Rajasthani Theme',  val: 'rajasthani' },
  { emoji: '🛕', label: 'Bengali Theme',     val: 'bengali' },
  { emoji: '🌍', label: 'African Theme',     val: 'african' },
  { emoji: '🥐', label: 'Parisian Bistro',   val: 'parisian' },
  { emoji: '🍝', label: 'Italian Trattoria', val: 'italian-vibe' },
  { emoji: '🌯', label: 'Mediterranean',     val: 'mediterranean' },
  { emoji: '🎸', label: 'Punjabi Dhaba',     val: 'punjabi-dhaba' },
  { emoji: '🏔️', label: 'Himalayan Theme',   val: 'himalayan' },
  { emoji: '🎋', label: 'Thai Theme',        val: 'thai-vibe' },
  { emoji: '🌵', label: 'Mexican Cantina',   val: 'mexican-vibe' },
  { emoji: '☘️', label: 'Irish Pub Vibe',    val: 'irish' },
];

export const CUISINE_CATS = [
  { emoji: '🍛', label: 'Indian', val: 'indian' },
  { emoji: '🥢', label: 'Chinese', val: 'chinese' },
  { emoji: '🍕', label: 'Italian', val: 'italian' },
  { emoji: '🌮', label: 'Mexican', val: 'mexican' },
  { emoji: '🍜', label: 'Thai', val: 'thai' },
  { emoji: '🍣', label: 'Japanese', val: 'japanese' },
  { emoji: '🍲', label: 'Korean', val: 'korean' },
  { emoji: '🍜', label: 'Vietnamese', val: 'vietnamese' },
  { emoji: '🍚', label: 'Indonesian', val: 'indonesian' },
  { emoji: '🍛', label: 'Malaysian', val: 'malaysian' },
  { emoji: '🍤', label: 'Singaporean', val: 'singaporean' },
  { emoji: '🍔', label: 'American', val: 'american' },
  { emoji: '🥧', label: 'British', val: 'british' },
  { emoji: '🥖', label: 'French', val: 'french' },
  { emoji: '🥘', label: 'Spanish', val: 'spanish' },
  { emoji: '🥙', label: 'Greek', val: 'greek' },
  { emoji: '🍖', label: 'Turkish', val: 'turkish' },
  { emoji: '🥙', label: 'Lebanese', val: 'lebanese' },
  { emoji: '🫒', label: 'Mediterranean', val: 'mediterranean' },
  { emoji: '🍢', label: 'Middle Eastern', val: 'middle_eastern' },
  { emoji: '🥘', label: 'Arabic', val: 'arabic' },
  { emoji: '🍢', label: 'Persian (Iranian)', val: 'persian' },
  { emoji: '🥨', label: 'German', val: 'german' },
  { emoji: '🥟', label: 'Russian', val: 'russian' },
  { emoji: '🥟', label: 'Polish', val: 'polish' },
  { emoji: '🥟', label: 'Ukrainian', val: 'ukrainian' },
  { emoji: '🥘', label: 'Hungarian', val: 'hungarian' },
  { emoji: '🍖', label: 'Brazilian', val: 'brazilian' },
  { emoji: '🥩', label: 'Argentinian', val: 'argentinian' },
  { emoji: '🍲', label: 'Peruvian', val: 'peruvian' },
  { emoji: '🥘', label: 'Colombian', val: 'colombian' },
  { emoji: '🍹', label: 'Caribbean', val: 'caribbean' },
  { emoji: '🥩', label: 'Cuban', val: 'cuban' },
  { emoji: '🍗', label: 'Jamaican', val: 'jamaican' },
  { emoji: '🥘', label: 'Ethiopian', val: 'ethiopian' },
  { emoji: '🍲', label: 'Moroccan', val: 'moroccan' },
  { emoji: '🥘', label: 'Tunisian', val: 'tunisian' },
  { emoji: '🍖', label: 'South African', val: 'south_african' },
  { emoji: '🍲', label: 'Nigerian', val: 'nigerian' },
  { emoji: '🍛', label: 'Kenyan', val: 'kenyan' },
  { emoji: '🥩', label: 'Australian', val: 'australian' },
  { emoji: '🥧', label: 'New Zealand', val: 'new_zealand' },
  { emoji: '🍽️', label: 'Fusion', val: 'fusion' },
  { emoji: '🍽️', label: 'Continental', val: 'continental' },
  { emoji: '🍔', label: 'Fast Food', val: 'fast_food' },
  { emoji: '🥙', label: 'Street Food', val: 'street_food' },
  { emoji: '🔥', label: 'BBQ', val: 'bbq' },
  { emoji: '🍖', label: 'Grill', val: 'grill' },
  { emoji: '🐟', label: 'Seafood', val: 'seafood' },
  { emoji: '🥗', label: 'Vegetarian', val: 'vegetarian' },
  { emoji: '🌱', label: 'Vegan', val: 'vegan' },
  { emoji: '🍰', label: 'Desserts', val: 'desserts' },
  { emoji: '🥐', label: 'Bakery', val: 'bakery' },
  { emoji: '☕', label: 'Cafe', val: 'cafe' },
  { emoji: '🥤', label: 'Beverages', val: 'beverages' },
];

export const OCCASION_FILTERS = [
  { emoji: '🎂', label: 'Birthday Party', val: 'birthday' },
  { emoji: '💍', label: 'Anniversary', val: 'anniversary' },
  { emoji: '🎊', label: 'Promotion Party', val: 'promotion' },
  { emoji: '🏢', label: 'Corporate Party', val: 'corporate' },
  { emoji: '🎓', label: 'Graduation Party', val: 'graduation' },
  { emoji: '👋', label: 'Farewell Party', val: 'farewell' },
  { emoji: '👨‍👩‍👧‍👦', label: 'Family Get-together', val: 'family' },
  { emoji: '🥳', label: 'Celebration Dinner', val: 'celebration' },
  { emoji: '🍾', label: 'Achievement Party', val: 'achievement' },
  { emoji: '💑', label: 'Date Night', val: 'date' },
  { emoji: '🤝', label: 'Business Meeting', val: 'business_meeting' },
  { emoji: '🎤', label: 'Event Hosting', val: 'event_hosting' },
  { emoji: '🎶', label: 'After Party', val: 'after_party' },
  { emoji: '🍻', label: 'Friends Hangout', val: 'friends' },
  { emoji: '🙏', label: 'Festive Gathering', val: 'festival' },
];

export const CUISINES_LIST = [
  { value: 'indian',       label: 'Indian'       },
  { value: 'chinese',      label: 'Chinese'      },
  { value: 'italian',      label: 'Italian'      },
  { value: 'mughlai',      label: 'Mughlai'      },
  { value: 'japanese',     label: 'Japanese'     },
  { value: 'south-indian', label: 'South Indian' },
];

/* Basic / structured filters — rating & distance are single-select
   inside their group (only one can be true at a time), diet & status
   stay multi-select toggle chips. */
export const RATING_OPTIONS = [
  { label: '⭐ 4.5+', value: 4.5 },
  { label: '⭐ 4.0+', value: 4.0 },
  { label: '⭐ 3.5+', value: 3.5 },
];

export const DISTANCE_OPTIONS = [
  { label: '📍 < 1 km', value: 1000 },
  { label: '📍 < 3 km', value: 3000 },
  { label: '📍 < 5 km', value: 5000 },
  { label: '📍 Any',    value: null },
];